module.exports = __webpack_public_path__ + "imgs/twitter-white.992688200921a669ec30dc79564c2bd1.svg";